global.userCashInHandTransactionList = global.API_USER_URL+'userCashInHandTransactionList/';
global.createCashInHandTransaction = global.API_USER_URL+'createCashInHandTransaction/';
global.editCashInHandTransaction = global.API_USER_URL+'editCashInHandTransaction/';
global.userCashInHandTransactionDetails = global.API_USER_URL+'userCashInHandTransactionDetails/';
